import { render, staticRenderFns } from "./step-1.vue?vue&type=template&id=6c60bb14&"
import script from "./step-1.vue?vue&type=script&lang=js&"
export * from "./step-1.vue?vue&type=script&lang=js&"
import style0 from "./step-1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./step-1.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports